import React, { createContext, useContext, useState, useEffect } from 'react';
import { logger } from '../../utils/logger';

const CompanyContext = createContext();

export function CompanyProvider({ children }) {
  const [companyInfo, setCompanyInfo] = useState({
    symbol: '',
    company_name: '',
    sector: '',
    industry: '',
    image: ''
  });

  // 从 localStorage 初始化数据
  useEffect(() => {
    const storedCompanyInfo = localStorage.getItem('companyInfo');
    if (storedCompanyInfo) {
      try {
        const parsedInfo = JSON.parse(storedCompanyInfo);
        setCompanyInfo(parsedInfo);
        logger.log('从 localStorage 加载公司信息:', parsedInfo);
      } catch (error) {
        logger.error('解析存储的公司信息失败:', error);
      }
    }
  }, []);

  // 更新公司信息
  const updateCompanyInfo = (newInfo) => {
    setCompanyInfo(newInfo);
    localStorage.setItem('companyInfo', JSON.stringify(newInfo));
    logger.log('更新公司信息:', newInfo);
  };

  return (
    <CompanyContext.Provider value={{ companyInfo, updateCompanyInfo }}>
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
} 